import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underinsured',
  templateUrl: './underinsured.component.html',
  styleUrls: ['./underinsured.component.scss']
})
export class UnderinsuredComponent implements OnInit {
  public newDisCardModal : boolean = false;
  newCardGroupNo: any = "";
  constructor() { }

  ngOnInit() {
    $(".underNavPh").click(function() {
      $('html,body').animate({
          scrollTop: $("#bestPriceRowId").offset().top},
          'slow');
  });
  }

  newDiscountModal() {
    this.newDisCardModal = true;
    this.newCardGroupNo = window.localStorage.getItem("UserGroup")

  }
  CloseNewCardModal(){
    this.newDisCardModal = false;
  }
  PrintMe() {
    setTimeout(() => {
      window.print();

    }, 600);
  }
}